import React from "react";
import { useHistory } from "react-router";
import { updateCandidateResume, uploadResume } from "../../../../APIs/PostAPIS";
import { Images } from "../../../../Assets/0a-exporter";
import SuccessModal from "../../../Common/SuccessModal/SuccessModal";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import "./upload-resume.style.scss";
export default function UploadResume({
  currentRoute,
  setNotification,
  completeIt,
}) {
  const history = useHistory();
  const context = React.useContext(MainContext);
  const { initialChecking } = context;
  const [resumeLink, setResumeLink] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [updating, setUpdating] = React.useState(false);
  const [successModal, setSuccessModal] = React.useState(false);

  const handleChange = async (event) => {
    setLoading(true);
    let doc = event.target.files[0];

    let ext = doc?.name?.toString()?.split(".");
    if (ext.length > 1) {
      let extension = ext[ext.length - 1];
      if (extension === "docx" || extension === "pdf") {
      } else {
        setLoading(false);
        setNotification({
          status: true,
          title: "Please Select only PDF or DOC file",
        });
        return;
      }
    } else {
      setLoading(false);
      setNotification({
        status: true,
        title: "Please Select only PDF or DOC file",
      });
      return;
    }
    
    if (doc.size > 10000000) {
      setLoading(false);
      setNotification({
        status: true,
        title: "File must be less than 10MB",
      });
      return;
    }

    const formData = new FormData();
    formData.append("newFile", doc);
    try {
      let res = await uploadResume(formData);
      if (res.data.data) {
        setResumeLink(res.data.data.file_link);
        setNotification({
          status: true,
          title: "File Uploaded",
        });
      } else {
        setNotification({
          status: true,
          title: "Something Went Wrong",
        });
      }
    } catch (error) {
      setNotification({
        status: true,
        title: "Something Went Wrong",
      });
    }

    setLoading(false);
  };
  const handleUpdate = async () => {
    setUpdating(true);
    try {
      let res = await updateCandidateResume({ candidate_resume: resumeLink });
      if (!res.data.error) {
        completeIt();
        initialChecking();
        setSuccessModal(true);
      } else {
        setNotification({
          status: true,
          title: res.data.message,
        });
      }
    } catch (error) {
      setNotification({
        status: true,
        title: "Something Went Wrong",
      });
    }
    setUpdating(false);
  };

  React.useEffect(() => {
    currentRoute();
  }, []);
  return (
    <div className="upload-resume-main-other">
      {successModal && <SuccessModal closeIt={() => setSuccessModal(false)} />}
      <header className="urm-header">
        <p>Step 5. Your CV / Resume</p>
      </header>
      <div className="urm-body">
        <div className="urm-info">
          <h6>Upload Your Resume*</h6>
          <p>Resume (Only doc, docx and pdf formats. Max size upto 50 MB)</p>
        </div>
        <label htmlFor="resume" className="drop-and-zone-area">
          <input
            onChange={(e) => {
              handleChange(e);
              e.target.value = "";
            }}
            id="resume"
            className="d-none"
            type="file"
            accept=".pdf, .doc"
          />
          <img
            src={
              !resumeLink
                ? Images.uploadLogo
                : "https://img.icons8.com/emoji/48/000000/check-box-with-check-emoji.png"
            }
          />
          <div>
            {loading ? (
              <h6>Loading....</h6>
            ) : resumeLink ? (
              <h6>File Uploaded</h6>
            ) : (
              <>
                <h6>Drag & Drop here or browse files</h6>
                <p>Resume (Only docs & pdf max upto 50 MB)</p>
              </>
            )}
          </div>
        </label>
      </div>
      <div className="urm-footer">
        <button onClick={() => history.push("/user/profile")}>Skip Step</button>
        <button
          disabled={!resumeLink}
          // onClick={() => history.push("/user/profile")}
          onClick={() => handleUpdate()}
        >
          {updating ? "Updating..." : "Update"}
        </button>
      </div>
    </div>
  );
}
